import { Box, Icon, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

const NoSoftwareFound = () => {
  return (
    <Box alignItems="center" justifyContent="center" paddingTop="s12">
      <Box
        background="grey200"
        gap="s12"
        alignItems="center"
        justifyContent="center"
        padding="s24"
        borderRadius={{
          all: 'abs008',
        }}
      >
        <Icon.Large icon="install" />
        <Text.Header2>
          {i18n.t('software_management.employee_software.detail.no_software_found.title')}
        </Text.Header2>
        <Text.Normal>
          {i18n.t(
            'software_management.employee_software.detail.no_software_found.installed_software_description'
          )}
        </Text.Normal>
      </Box>
    </Box>
  )
}

export default NoSoftwareFound
